export default __webpack_public_path__ + "static/media/ec.34a64a77.svg";